import {
  SIGN_IN,
  SIGN_IN_SUCCESS,
  SIGN_IN_FAILED,
  ADD_ACCOUNT,
  ADD_ACCOUNT_SUCCESS,
  ADD_ACCOUNT_FAILED,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAILED,
  ADD_ROLED_USER,
  ADD_ROLED_USER_SUCCESS,
  ADD_ROLED_USER_FAILED,
  FETCH_USER,
  FETCH_USER_SUCCESS,
  FETCH_USER_FAILED,
  FETCH_USERS,
  FETCH_USERS_SUCCES,
  FETCH_USERS_FAILED,
  SIGNED_OUT,
  EDIT_USER_INFO,
  FETCH_FORGOT_PASSWORD,
  FETCH_FORGOT_PASSWORD_FAILED,
  FETCH_FORGOT_PASSWORD_SUCCESS,
  CHECK_EMAIL,
  CHECK_EMAIL_FAILED,
  CHECK_EMAIL_SUCCESS,
  SEND_EMAIL,
  SEND_EMAIL_SUCCES,
  SEND_EMAIL_FAILED,
  UPDATE_ROLE,
  UPDATE_ROLE_SUCCES,
  UPDATE_ROLE_FAILED
} from "./constants";
import history from "../../history";
import { updateEvaluationAuthor } from "../evaluation/actions";
import { sendEmailTa } from "../emails/actions";
import db from "../../firebaseAPI";
import { DeleteUserURL, OnRegisteredUserURL } from "./../emails/endpoints"

var config = {
  // apiKey: "AIzaSyBBcB_Yboc3_bejk6n7MesTB73V588iCsw",
  // authDomain: "ilead-website.firebaseapp.com",
  // databaseURL: "https://ilead-website.firebaseio.com",
  // projectId: "ilead-website",
  // storageBucket: "ilead-website.appspot.com",
  // messagingSenderId: "924367937702"
  apiKey: "AIzaSyBlqiuts4NNTNT9nCjS3v7QlYw9T9nEp9w",
  authDomain: "ilead-2154a.firebaseapp.com",
  databaseURL: "https://ilead-2154a.firebaseio.com",
  projectId: "ilead-2154a",
  storageBucket: "ilead-2154a.appspot.com",
  messagingSenderId: "135036900258"
};

var adminAuth = window.firebase.initializeApp(config, "adminAuth");

//Update userInfo

export function updateUserRequest(data) {
  return {
    type: EDIT_USER_INFO,
    payload: {
      data
    }
  };
}

export function updateUser(data) {
  return dispatch => {
    dispatch(updateUserRequest(data));
  };
}

export function deleteUserRequest() {
  return {
    type: DELETE_USER,
    payload: {}
  };
}

export function deleteUserSuccess() {
  return {
    type: DELETE_USER_SUCCESS,
    payload: {}
  };
}

export function deleteUserFailed(userId, payload) {
  return {
    type: DELETE_USER_FAILED,
    payload: {
      userId,
      data: { ...payload }
    }
  };
}

export function deleteUser(uid) {
  return dispatch => {
    dispatch(deleteUserRequest());

    db.collection("users")
      .doc(uid)
      .delete();

    fetch(DeleteUserURL, {
      method: "POST",
      mode: "no-cors",

      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        uid: uid
      }),
    })
      .then(function(doc) {
        dispatch(deleteUserSuccess());
      })
      .catch(function(error) {
        dispatch(deleteUserFailed(error));
      });
  };
}

export function checkEmailRequest() {
  return {
    type: CHECK_EMAIL,
    payload: {}
  };
}

export function checkEmailSuccess(message, userExists) {
  return {
    type: CHECK_EMAIL_SUCCESS,
    payload: { message },
    userExists: true
  };
}

export function checkEmailFailed(payload) {
  return {
    type: CHECK_EMAIL_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function checkEmail(email, userExists) {
  return dispatch => {
    dispatch(checkEmailRequest());

    return window.firebase
      .auth()
      .fetchProvidersForEmail(email)
      .then(function(doc) {
        dispatch(checkEmailSuccess(doc, userExists));
      })
      .catch(function(error) {
        dispatch(checkEmailFailed(error));
      });
  };
}

export function addUserRequest() {
  return {
    type: ADD_ROLED_USER,
    payload: {}
  };
}

export function addUserSuccess(data) {
  return {
    type: ADD_ROLED_USER_SUCCESS,
    payload: { data }
  };
}

export function addUserFailed(payload) {
  return {
    type: ADD_ROLED_USER_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function addUser(email, role, name) {
  return dispatch => {
    dispatch(addUserRequest());
    const password = Math.random()
      .toString(36)
      .slice(-8);

    return adminAuth
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(user => {
        dispatch(addAccountSuccess());

        dispatch(addUserRequest());
        return db
          .collection("users")
          .doc(user.uid)
          .set({
            email: email,
            role: role,
            name: name
          })
          .then(function(doc) {
            if (role === "ta") {
              dispatch(sendEmailTa(email, name, "dk", password));
            }
            dispatch(addUserSuccess(doc));
          })
          .catch(function(error) {
            dispatch(addUserFailed(error));
          });
      })
      .catch(function(error) {
        dispatch(addAccountFailed(error));
      });
  };
}

///FetchAll results

export function requestUsers() {
  return {
    type: FETCH_USERS,
    payload: {}
  };
}

export function loadedUsers(users) {
  // LocalStorage.setItem('token', response.header['x-session-id']);

  return {
    type: FETCH_USERS_SUCCES,
    payload: {
      data: users
    }
  };
}

export function failedUsers(key, payload) {
  return {
    type: FETCH_USERS_FAILED,
    payload: {
      isFetching: true,
      key,
      data: { ...payload }
    }
  };
}

export function fetchUsers() {
  return dispatch => {
    dispatch(requestUsers());
    return db.collection("users").onSnapshot(
      function(querySnapshot) {
        const users = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        dispatch(loadedUsers(users));
      },

      function(error) {
        dispatch(failedUsers(error));
      }
    );
  };
}

export function updateRoleRequest() {
  return {
    type: UPDATE_ROLE,
    payload: {}
  };
}

export function updateRoleSucces() {
  return {
    type: UPDATE_ROLE_SUCCES,
    payload: {}
  };
}

export function updatedRoleFailed(payload) {
  return {
    type: UPDATE_ROLE_FAILED,
    payload: { data: { ...payload } }
  };
}

export function updateRole(uid) {
  return dispatch => {
    dispatch(updateRoleRequest());

    return db
      .collection("users")
      .doc(uid)
      .get()
      .then(userData => {
        if(userData.data().role !== "admin") {
          db
          .collection("users")
          .doc(uid)
          .update({ role: "ta" })
        }

        return null;
      })

      .then(data => {
        dispatch(updateRoleSucces());
      })
      .catch(function(error) {
        dispatch(updateRole(error));
      });
  };
}

export function addAccountRequest() {
  return {
    type: ADD_ACCOUNT,
    payload: {}
  };
}

export function addAccountSuccess(data) {
  return {
    type: ADD_ACCOUNT_SUCCESS,
    payload: { data }
  };
}

export function addAccountFailed(payload) {
  return {
    type: ADD_ACCOUNT_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function addAccount(
  email,
  password,
  name,
  age,
  education,
  experience,
  references,
  evaluationId
) {
  return dispatch => {
    dispatch(addAccountRequest());

    return window.firebase
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .then(user => {
        db.collection("users")
          .doc(user.uid)
          .set({
            name: name,
            email: email,
            age: age,
            education: education,
            experience: experience,
            references: references
          });

        dispatch(addAccountSuccess(user));
        dispatch(updateEvaluationAuthor(evaluationId, user.uid));
      })
      .catch(function(error) {
        dispatch(addAccountFailed(error));
      });
  };
}

export function signInRequest() {
  return {
    type: SIGN_IN,
    payload: {}
  };
}

export function signInSuccess(user, type) {
  return {
    type: SIGN_IN_SUCCESS,
    payload: {
      user,
      type
    }
  };
}

export function signInFailed(payload) {
  return {
    type: SIGN_IN_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function getUserData(user, type) {
  return dispatch => {
    db.collection("users")
      .doc(user.uid)
      .get()
      .then(function(doc) {
        const userData = { ...doc.data(), ...user };
        dispatch(signInSuccess(userData, type));
      });
  };
}

export function signInUser(email, password, type, id) {
  return dispatch => {
    dispatch(signInRequest());
    window.firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(async user => {
        if (type === "admin") {
          db.collection("users")
            .doc(user.uid)
            .get()
            .then(userData => {
              if (window.location.pathname === "/sign-in") {
                const data = userData.data();
                if (data && data.role === "admin") {
                  return history.push({
                    pathname: `/front-page/${user.uid}`,
                    state: { isAdmin: true, isTa: true }
                  });
                }
                if (data && data.role === "ta") {
                  return history.push({
                    pathname: `/front-page/${user.uid}`,
                    state: { isTa: true }
                  });
                }
                db.collection("evaluations")
                  .where("userId", "==", user.uid)
                  .orderBy("createTime")
                  .limit(1)
                  .get()
                  .then(function(collection) {
                    if (collection.docs[0]) {
                      // return history.push(
                      //   `/survey/${collection.docs[0].id}/results?step=REPORT`
                      // );

                      return history.push(`/front-page/${user.uid}`);
                    }
                    // return history.push("/admin/blog");
                  })
                  .catch(function(error) {
                  });
              } else {
                return history.push({
                  pathname: window.location.pathname
                });
              }
            })
            .catch(function(error) {
            });
        }

        if (type === "results") {
          history.push(
            `/${
              window.location.pathname.split("/")[1]
            }/survey/${id}/results?step=REPORT`
          );
          // history.push(`/front-page/${id}`);
        }

        getUserData(user, type);
      })
      .catch(function(error) {
        // Handle Errors here.
        dispatch(signInFailed(error));
      });
  };
}

export function signedOut() {
  return {
    type: SIGNED_OUT,
    payload: {}
  };
}

export function getUserRequest() {
  return {
    type: FETCH_USER,
    payload: {}
  };
}

export function getUserSuccess(userData) {
  return {
    type: FETCH_USER_SUCCESS,
    payload: {
      userData
    }
  };
}

export function getUserFailed(payload) {
  return {
    type: FETCH_USER_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function getUser(uid) {
  return async dispatch => {
    dispatch(getUserRequest());
    return db
      .collection("users")
      .doc(uid)
      .get()
      .then(userData => {
        dispatch(getUserSuccess(userData.data()));
      })
      .catch(function(error) {
        dispatch(getUserFailed(error));
      });
  };
}

export function forgotPasswordRequest() {
  return {
    type: FETCH_FORGOT_PASSWORD,
    payload: {}
  };
}

export function forgotPasswordSuccess() {
  return {
    type: FETCH_FORGOT_PASSWORD_SUCCESS,
    payload: {}
  };
}

export function forgotPasswordFailed(payload) {
  return {
    type: FETCH_FORGOT_PASSWORD_FAILED,
    payload: {
      data: { ...payload }
    }
  };
}

export function forgotPassword(email) {
  return async dispatch => {
    dispatch(forgotPasswordRequest());
    return window.firebase
      .auth()
      .sendPasswordResetEmail(email)
      .then(() => {
        dispatch(forgotPasswordSuccess());
      })
      .catch(function(error) {
        dispatch(forgotPasswordFailed(error));
      });
  };
}

export function sendEmailRequest() {
  return {
    type: SEND_EMAIL,
    payload: {}
  };
}

export function sendEmailSucces(response) {
  return {
    type: SEND_EMAIL_SUCCES,
    payload: {
      response
    }
  };
}

export function sendEmailFailed(payload, error) {
  return {
    type: SEND_EMAIL_FAILED,
    payload: {
      data: { ...payload },
      error
    }
  };
}

export function sendEmail(email, name, language) {
  return async dispatch => {
    //    dispatch(sendEmailRequest());

    return fetch(
      OnRegisteredUserURL,
      {
        method: "POST",
        mode: "no-cors",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          email: email,
          name: name,
          language: language
        }),
      }
    )
      .then(function(response) {
        if (response.ok) {
          //     return dispatch(sendEmailSucces(response));
        }
      })
      .catch(function(error) {
        //     return dispatch(sendEmailFailed(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/modules/user/actions.js